import { DropdownOptionProps } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';

export enum BudgetResetTypeValues {
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS',
}

export const budgetResetTypeOptions: DropdownOptionProps[] = [
  { value: BudgetResetTypeValues.DAYS, text: 'Days' },
  { value: BudgetResetTypeValues.WEEKS, text: 'Weeks' },
  { value: BudgetResetTypeValues.MONTHS, text: 'Months' },
];
